
import { Check, Loader2, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ReviewActionsProps {
  onApprove: () => void;
  onReject: () => void;
  isUpdating: boolean;
}

export function ReviewActions({ onApprove, onReject, isUpdating }: ReviewActionsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Review Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button 
          className="w-full"
          onClick={onApprove}
          disabled={isUpdating}
        >
          {isUpdating ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Check className="mr-2 h-4 w-4" />}
          Approve Document
        </Button>
        <Button 
          variant="destructive" 
          className="w-full"
          onClick={onReject}
          disabled={isUpdating}
        >
          {isUpdating ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <X className="mr-2 h-4 w-4" />}
          Reject Document
        </Button>
      </CardContent>
    </Card>
  );
}
